<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <router-link to="/cart" class="btn"><span class="fa fa-shopping-cart"></span> CART {{ cart.count }} ITEMS - ${{ price_format(cart.total) }}</router-link>
                <div class="alert alert-success" v-if="alert.item">
                    <span class="fa fa-check-circle mr-1"></span>
                    <p><b>{{ alert.item }}</b> has been added to your cart.</p>
                    <router-link to="/cart" class="btnViewCart">View Cart</router-link>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-lg-12">
                <div class="filter-wrapper" :class="layout">
                    <p class="title">Manage Filters:</p>
                    <div class="filter-container">
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.product_type" @change="get_product_models(); get_part_types(); filter_list();">
                                <option value="all">Product Type: All</option>
                                <option v-for="(row, key) in product_types" :key="key" :value="row.id">{{ row.name }}</option>
                            </select>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.product_model" @change="get_product_numbers(); filter_list();">
                                <option value="all">Product Model: All</option>
                                <option v-for="(row, key) in product_models" :key="key" :value="row.id">{{ row.name }}</option>
                            </select>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.product_number" @change="filter_list">
                                <option value="all">Product Number: All</option>
                                <option v-for="(row, key) in product_numbers" :key="key" :value="row.id">{{ row.name }}</option>
                            </select>
                        </div>
                        <div class="filter-item">
                            <select class="nice-select" v-model="filters.part_type" @change="filter_list">
                                <option value="all">Part Type: All</option>
                                <option v-for="(row, key) in part_types" :key="key" :value="row.id">{{ row.name }}</option>
                            </select>
                        </div>
                        <div class="filter-item search-filter">
                            <input type="text" placeholder="Search" v-model="filters.search" @change="filter_list">
                            <button type="button" @click="filter_list"><i class="fa fa-search"></i></button>
                        </div>
                        <div class="filter-reset-btn">
                            <a href="javascript:void(0)" title="Refresh" @click="reset_filter">
                                <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="table-responsive">
                    <div id="ses-list" class="list-proj" @scroll="scroll_list">
                        <div class="row list-head">
                            <div class="col" data-key="item" @click="sort_list">TDI PART #</div>
                            <div class="col" data-key="description" @click="sort_list">Description</div>
                            <div class="col sort-false">Picture</div>
                            <div class="col" data-key="price" @click="sort_list">Price</div>
                        </div>
                        <div class="list-row" v-for="row in spare_parts" :key="row.id">
                            <div class="row list-data">
                                <div class="col">{{ row.item }}</div>
                                <div class="col">{{ row.description }}</div>
                                <div class="col">
                                    <div class="image-wrap">
                                        <img :src="row.image ? row.image : '/api/public/img/item-placeholder.png'" class="image">
                                    </div>    
                                </div>
                                <div class="col">${{ price_format(row.price) }}</div>
                            </div>
                            <div class="row list-action">
                                <div class="col-md-12 action-wrap">
                                    <template v-if="row.price && row.price > 0">
                                        <a href="javascript:void(0);" class="action action-blue" @click="view(row.id)"><span class="fa fa-eye"></span> View Details</a>
                                        <a href="javascript:void(0);" class="action" @click="add_to_cart($event, row)"><span>$</span> Add to Cart</a>
                                    </template>
                                    <template v-else>
                                        <span class="not-available">Not available</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="spare_parts.length == 0 && !isListLoading">
                        <p class="no-results-msg">No results found</p>
                    </template>
                    <template v-if="isListLoading">
                        <div class="progress">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <template v-if="id > 0">
            <spare-part-modal :id="id" :key="id" :show="showViewModal" @close="close_view_modal"></spare-part-modal>
        </template>
    </div>
</template>
<script>
import SparePartModal from '../../components/Modals/SparePartModal.vue'

let alert;

export default {
    name: 'spare-parts',
    components: { SparePartModal },
    data() {
        return {
            layout: '',
            isListLoading: false,
            showViewModal: false,
            spare_parts: [],
            product_types: [],
            product_models: [],
            product_numbers: [],
            part_types: [],
            page: 1,
            last_page: 1,
            order_by: 'item',
            order: 'asc',
            filters: {
                search: '',
                product_type: 'all',
                product_model: 'all',
                product_number: 'all',
                part_type: 'all'
            },
            id: 0,
            cart: {
                count: 0,
                total: '0.00'
            },
            alert: {
                item: ''
            }
        }
    },
    mounted() {
        let user = localStorage.getItem('user')
        if(!user) {
            this.layout = 'guest'
        }
        
        this.get_spare_parts()
        this.calculate_cart()
        this.get_product_types()
    },
    watch: {
        'alert.item'(n) {
            if(n) {
                clearTimeout(alert)
                alert = setTimeout(() => { this.alert.item = '' }, 10000)
            }
        }
    },
    methods: {
        get_spare_parts() {
            this.isListLoading = true
            this.$http.get('/api/spare-parts?page=' + this.page 
                    + '&order_by=' + this.order_by
                    + '&order=' + this.order
                    + '&filters=' + JSON.stringify(this.filters)
                )
                .then((response) => {
                    if(this.page == 1) {
                        this.spare_parts = []
                    }
                    response.data.data.forEach(row => {
                        this.spare_parts.push(row)
                    })
                    this.last_page = response.data.last_page
                    this.isListLoading = false
                })
        },
        get_product_types() {
            this.product_types = []
            this.filters.part_type = 'all'

            this.$http.get('/api/product_categories/children/Product Type')
                .then((response) => {
                    this.product_types = response.data
                })
        },
        get_product_models() {
            this.filters.product_model = 'all'
            this.filters.product_number = 'all'
            this.product_models = []

            if(this.filters.product_type != 'all') {
                this.$http.get('/api/product_categories/children/' + this.filters.product_type)
                    .then((response) => {
                        this.product_models = response.data
                    })
            }
        },
        get_product_numbers() {
            this.filters.product_number = 'all'
            this.product_numbers = []

            if(this.filters.product_model != 'all') {
                this.$http.get('/api/product_categories/children/' + this.filters.product_model)
                    .then((response) => {
                        this.product_numbers = response.data
                    })
            }
        },
        get_part_types() {
            this.filters.part_type = 'all'
            this.part_types = []

            if(this.filters.product_type != 'all') {
                this.$http.get('/api/product_categories/children/Part Type?product_type=' + this.filters.product_type)
                    .then((response) => {
                        this.part_types = response.data
                    })
            }
        },
        view(id) {
            this.id = id
            this.showViewModal = true
        },
        close_view_modal() {
            this.id = 0
            this.showViewModal = false
            this.calculate_cart()
        },
        add_to_cart(e, model) {
            let def_txt = e.target.innerHTML
            e.target.innerHTML = '<span class="fa fa-pulse fa-spinner" style="font-size: 12px; background: none; width: auto; margin: -7px auto;"></span>'
            
            if(!model.image) {
                model.image = '/api/public/img/item-placeholder.png'
            }

            model.quantity = 1
            model.total = 0

            let cart = localStorage.getItem('cart')
            let total = parseFloat(model.price) * parseInt(model.quantity)
            model.total = total.toFixed(2)

            if(!cart) {
                cart = [model]
            } else {
                cart = JSON.parse(cart)
                let exist = false
                for(let x in cart) {
                    if(cart[x].id == model.id) {
                        cart[x].price = model.price
                        cart[x].quantity = parseInt(model.quantity) + parseInt(cart[x].quantity)
                        let total = parseFloat(cart[x].price) * parseInt(cart[x].quantity)
                        cart[x].total = total.toFixed(2)
                        exist = true
                        break
                    }
                }
                if(!exist) {
                    cart.push(model)
                }
            }
            setTimeout(() => { e.target.innerHTML = def_txt }, 300)
            localStorage.setItem('cart', JSON.stringify(cart))
            this.calculate_cart()
            this.alert.item = model.item
        },
        calculate_cart() {
            let cart = localStorage.getItem('cart')
            if(cart) {
                let total = 0
                let count = 0
                cart = JSON.parse(cart)
                for(let x in cart) {
                    total = parseFloat(total) + parseFloat(cart[x].total)
                    count = parseInt(count) + parseInt(cart[x].quantity)
                }
                this.cart.total = total.toFixed(2)
                this.cart.count = count
            }
        },
        scroll_list(e) {
            if(e.target.scrollTop + e.target.clientHeight >= (e.target.scrollHeight - 50) && !this.isListLoading) {
                this.page += 1
                if(this.page <= this.last_page) {
                    this.get_spare_parts()
                }
            }
        },
        sort_list(e) {
            if(!this.isListLoading) {
                Array.from(document.querySelectorAll('#ses-list .list-head .col')).forEach((el) => {
                    el.classList.remove('asc', 'desc')
                })
                let element = document.querySelector('#ses-list .list-head .col[data-key='+e.target.dataset.key+']')
                this.order_by = e.target.dataset.key
                this.order = element.dataset.order || 'asc'
                element.classList.add(this.order)
                element.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
                this.page = 1
                this.spare_parts = []
                this.get_spare_parts()
            }
        },
        filter_list() {
            this.page = 1
            this.spare_parts = []
            this.get_spare_parts()
        },
        reset_filter() {
            this.filters = {
                search: '',
                product_type: 'all',
                product_model: 'all',
                product_number: 'all',
                part_type: 'all'
            }
            this.product_models = []
            this.product_numbers = []
            this.part_types = []
            this.page = 1
            this.spare_parts = []
            this.get_spare_parts()
        },
        price_format(num) {
            return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
    }
}
</script>
<style lang="scss" scoped>
#ses-list {
    min-width: 700px;
    padding-right: 12px;
    .list-head .col {
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url('/api/public/img/bg.png');
        background-position: center right;
        background-repeat: no-repeat;
        cursor: pointer;
        white-space: normal;
        &.asc {
            background-image: url('/api/public/img/trans-asc.png');
        }
        &.desc {
            background-image: url('/api/public/img/trans-desc.png');
        }
        &.sort-false {
            background-image: none;
            cursor: default;
        }
    }
}
.progress {
    border-radius: 0;
}
.no-results-msg {
    text-align: center;
    padding: 0.5em;
    font-size: 11px;
}
.image-wrap {
    position: absolute;
    width: 60px;
    height: 60px;
    margin-top: 32px;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
    .image {
        width: 60px;
        height: 60px;
    }
    &:hover {
        z-index: 999;
        .image {
            border: 2px solid #ccc;
            width: 240px;
            height: auto;
            position: absolute;
            transform: translate(-50%, -10%);
        }
    }
}
.list-data {
    min-height: 40px;
}
.list-proj .row .action-wrap { white-space: nowrap; position: relative; z-index: 2; text-align: left; }
.list-proj .row .action { display: inline-block; text-align: center; height: 30px; padding: 7px; border: 0; letter-spacing: 0.3px; color: #fff; text-decoration: none; min-width: 86px; cursor: pointer; color: #fff; background-color: #5cb85c; margin-left: 6px; vertical-align: middle; }
.list-proj .row .action span { display: inline-block; background: #459e45; padding: 2px 7px; width: 29px; margin: -7px 2px -7px -8px; font-size: 17px; line-height: 26px; text-align: center; }
.list-proj .row .action.action-blue { background: #337ab7; }
.list-proj .row .action.action-blue span { background: #055091; }
.not-available {
    color: #c90000;
    display: inline-block;
    text-align: center;
    height: 30px;
    padding: 7px;
    margin-left: 6px;
}
.alert {
    margin-top: 1em;
    margin-bottom: 0;
    padding: 0.8em;
    background-color: #f7f6f7;
    color: #515151;
    border-radius: 0;
    display: flex;
    align-items: center;
    p {
        flex: auto;
        margin: 0;
    }
}
.alert-success {
    border: 0;
    border-top: 2px solid #459e45;
    .fa {
        color: #459e45;
        font-size: 14px;
    }
}
.btnViewCart {
    color: #515151;
    background-color: #ebe9eb;
    padding: 0.5em 1em;
    border-radius: 3px;
    font-weight: 700;
}
@media (min-width: 1200px) {
    .filter-wrapper {
        .filter-item {
            width: 24.6% !important;
        }
        &.guest {
            .filter-item {
                width: 19.2% !important;
            }
        }
    }
}
@media (max-width: 768px) {
    #ses-list {
        min-width: 1200px;
    }
}
</style>